var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","background":"#FFFFFF","text-align":"center"},attrs:{"id":"consoleCPU"}},[_c('ve-line',{ref:"consoleCPU",attrs:{"data":_vm.chartData,"extend":_vm.extend,"width":"100%","height":"100%","legend-visible":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6d5c890","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/ConsoleCPU.vue
// module id = null
// module chunks = 